const slider = document.querySelector('#scroll-through');
const related = document.querySelector('#related');
const rightBtn = document.querySelector('#scrollRight');
const leftBtn = document.querySelector('#scrollLeft');
const slideR = document.querySelector('#slideRight');
const slideL = document.querySelector('#slideLeft');

const toggleMenu = document.querySelector('#toggleMenu');
const menu = document.getElementById('menu');
const searchicon = document.getElementById('search_trigger');

const logo = document.getElementsByClassName('headerLogo')
const narrow = document.querySelector('.narrow')
const wide = document.querySelector('.wide')
const contentEl = $('#single_feature')[0];


$(menu).each(function() {

  document.querySelectorAll('a.parent').forEach(parent => {
    parent.addEventListener('click', event => {
      event.preventDefault();

      const wrapper = parent.parentElement;
      const mega = wrapper.querySelector('.childMenu');

      // Close all other mega menus
      document.querySelectorAll('.hasChildren').forEach(item => {
        if (item !== wrapper) {
          item.classList.remove('active');
          item.querySelector('.childMenu')?.classList.remove('open');
        }
      });

      // Toggle this menu
      wrapper.classList.toggle('active');
      mega.classList.toggle('open');
      searchicon.classList.remove('active');
    });
  });

  $('.headerLogo').insertAfter('header .header__menu')
  $('.parent').each(function(){
    $(this).removeAttr('href');
    $(this).append(`
      <svg id="arrow" xmlns="http://www.w3.org/2000/svg" width="1.75rem" height="1.75rem" viewBox="0 0 204 204"><g id="Group_144" data-name="Group 144" transform="translate(-49.999 -0.221)"><rect id="circle" data-name="Rectangle 43" width="204" height="204" rx="102" transform="translate(49.999 0.221)" opacity="0.998"/><g id="Group_49" data-name="Group 49" transform="translate(86.415 52.263)">  <rect id="Rectangle_22" data-name="Rectangle 22" width="125.553" height="14.161" rx="6" transform="translate(0 41.798)"/>  <path id="Polygon_1" data-name="Polygon 1" d="M45.061,3.148a6,6,0,0,1,7.635,0L84.869,29.681A6,6,0,0,1,81.052,40.31H16.706a6,6,0,0,1-3.817-10.629Z" transform="translate(133.162 0) rotate(90)"/></g></g></svg>
    `)
  })
  $('.hasChildren').find('href').removeAttr('href')
})

toggleMenu.addEventListener('keypress', (event) => {
  $(toggleMenu).toggleClass('active')
  $(searchicon).removeClass('active')
  
  if ($('.hasChildren').hasClass('acitve')) {
    $(this).removeClass('acitve')
  }
  $('.childMenu').removeClass('open')
});

toggleMenu.addEventListener('click', (event) => {
  $(toggleMenu).toggleClass('active')
  $(searchicon).removeClass('active')

  if ($('.hasChildren').hasClass('acitve')) {
    $(this).removeClass('acitve')
  }
  $('.childMenu').removeClass('open')
});

searchicon.addEventListener('keypress', (event) => {
  $(searchicon).toggleClass('active')
  $(toggleMenu).removeClass('active')
  $('.hasChildren').removeClass('active')
  $('.childMenu').removeClass('open')
});
searchicon.addEventListener('click', (event) => {
  $(searchicon).toggleClass('active')
  $(toggleMenu).removeClass('active')
  $('.hasChildren').removeClass('active')
  $('.childMenu').removeClass('open')
});

function isInViewport(el) {

  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}

if(rightBtn){
    rightBtn.addEventListener("click", function (event) {
      console.log('clicked')
        const conent = document.querySelector('#scroll-through');
        conent.scrollLeft += 500;
        event.preventDefault();
    });
}

if(leftBtn){
    leftBtn.addEventListener("click", function (event) {
      console.log('clicked')
        const conent = document.querySelector('#scroll-through');
        conent.scrollLeft -= 500;
        event.preventDefault();
    });
}

if(slideR){
    slideR.addEventListener("click", function (event) {
      console.log('clicked')
        const relatedItems = document.querySelector('#related');
        relatedItems.scrollLeft += 500;
        event.preventDefault();
    });
}

if(slideL){
    slideL.addEventListener("click", function (event) {
      console.log('clicked')
        const relatedItems = document.querySelector('#related');
        relatedItems.scrollLeft -= 500;
        event.preventDefault();
    });
}

let isDown = false; 

if(slider){

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
        console.log(walk);
    });
}
if(related){

    related.addEventListener('mousedown', (e) => {
        isDown = true;
        related.classList.add('active');
        startX = e.pageX - related.offsetLeft;
        scrollLeft = related.scrollLeft;
    });
    related.addEventListener('mouseleave', () => {
        isDown = false;
        related.classList.remove('active');
    });
    related.addEventListener('mouseup', () => {
        isDown = false;
        related.classList.remove('active');
    });
    related.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - related.offsetLeft;
        const walk = (x - startX) * 1; //scroll-fast
        related.scrollLeft = scrollLeft - walk;
        console.log(walk);
    });

    if( $(window).width() > 767 ) {
      if( $('#related .item').length < 5 ) {
        $('.related nav').hide();
      }
    }
}

$('.carousel-item a').on({
  mouseenter: function () {
    $(this).closest('.carousel-item').addClass('hovered');
  },
  mouseleave: function () {
    $(this).closest('.carousel-item').removeClass('hovered');
  }
});

$(window).on('scroll', function() {

  if ($(this).scrollTop() > 10) {
    $('.headerContainer').addClass('opacity');
    $('#search_container').addClass('shift');
  } else {
    $('.headerContainer').removeClass('opacity');
    $('#search_container').removeClass('shift');
  }

  if (isInViewport(contentEl) && $(this).scrollTop() > 10) {
    $(contentEl).addClass('hi')
    return false;
  } 

});

function elementInViewport($el) {
  const rect = $el[0].getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  );
}

const whatsapp = $('.whatsAppBanner');

function checkFooterVisibility() {
  if (elementInViewport($('footer'))) {
    whatsapp.hide(500);
  } else {
    whatsapp.show(500);
  }
}

$(window).on('scroll resize', checkFooterVisibility);
checkFooterVisibility(); // Run on page load


if(narrow && wide){

  narrow.addEventListener("click", function (event) {
    const item = document.querySelector('#productListing')
    $(item).addClass('narrow')
    $(item).removeClass('wide')

    if( $(item).hasClass('narrow') ) {
      $('.sizeSelection .narrow').addClass('active')
      $('.sizeSelection .wide').removeClass('active')}
    
  })

  wide.addEventListener("click", function (event) {
    const item = document.querySelector('#productListing')
    $(item).addClass('wide')
    $(item).removeClass('narrow')


    if( $(item).hasClass('wide') ) {
      $('.sizeSelection .narrow').removeClass('active')
      $('.sizeSelection .wide').addClass('active')
    }

  })
}

// $('.left, .right').on('click', function () {
//   const container = $(this).closest('.productImages'); 
//   const isLeft = $(this).hasClass('left');

//   container
//     .toggleClass('shiftLeft', isLeft)
//     .toggleClass('shiftRight', !isLeft);
// });


$('.collection-product__content').on({
  mouseenter: function () {
    $(this).addClass('hovered');
  },
  mouseleave: function () {
    $(this).removeClass('hovered');
  }
});


$('span.all').click(function(){
  $(this).toggleClass('open');
  $('.product').toggleClass('open');
})


const delivery = document.getElementById('delivery');
const productForm = document.querySelector('.product-form');
const card = document.querySelector('#cart .rightContainer');

if (delivery) {

  if (productForm) {
    productForm.appendChild(delivery);
  }
  if (card) {
    card.appendChild(delivery);
  }

  delivery.addEventListener("click", () => {
    delivery.getAttribute("class") === "collapse" ? delivery.setAttribute("class", "expand") : delivery.setAttribute("class", "collapse")
  })
}



const faq = document.getElementById('faq')

if (faq) {

  document.querySelectorAll('.item .title').forEach(parent => {
    parent.addEventListener('click', event => {
      event.preventDefault();

      const wrapper = parent.parentElement;

      // Close all other accordion items
      document.querySelectorAll('.item').forEach(item => {
        if (item !== wrapper) {
          item.classList.remove('open');
        }
      });

      // Toggle current item
      wrapper.classList.toggle('open');
    });
  });

}
